export const documentsTableRowKebabSx = {
  minWidth: '24px',
  width: '24px',
  maxWidth: '24px',
  padding: 0,
}
